import { GetActivitiesPaginatedResponse } from '../../app/features/activity/domain/activity.model';
import { ActivityNameStatus } from '../../app/features/activity/infrastructure/enums/activity-name-status.enum';
import { ActivityReason } from '../../app/features/activity/infrastructure/enums/activity-reason.enum';
import { ActivityType } from '../../app/features/activity/infrastructure/enums/activity-type.enum';
import { MROType } from '../../app/features/vehicles/infrastructure/enums/mro-type.enum';

export const activityPaginatedMock: GetActivitiesPaginatedResponse = {
    data: [
        {
            id: "d8c950g9-0b86-5e13-08eg-79e0b8e7b66d",
            type: ActivityType.RUC,
            status: {
                name: ActivityNameStatus.CREATED,
                reason: ActivityReason.ACTIVITY_CREATED,
                dateTime: "2025-04-31T16:45:00Z"
            },
            vehicle: {
                vin: "JH4DA9470MS016525",
                details: {
                    make: "Kia",
                    model: "Niro Hybrid",
                    year: 2023
                },
                licensePlate: "KIA-1234",
                licensePlateState: "CA"
            },
            entry: {
                timestamp: "2025-03-31T04:00:00Z"
            },
            exit: {
                timestamp: "2025-06-27T04:00:00Z"
            },
            mroType:MROType.ODOMETER_CAPTURE,
            distance: {
                value: 1999.3,
                unit: "mi"
            },
            locationName: "Location 1",
            totalAmount: {
                amount: 24.06,
                currency: "USD"
            },
            createdAt: "2025-06-27T04:00:00Z"
        },
        {
            id: "d8c950g9-0b64-5e13-08eg-79e0b8e7b66d",
            type: ActivityType.RUC,
            status: {
                name: ActivityNameStatus.CREATED,
                reason: ActivityReason.ACTIVITY_CREATED,
                dateTime: "2025-04-31T16:45:00Z"
            },
            vehicle: {
                vin: "JH4DA8750MS016526",
                details: {
                    make: "Renault",
                    model: "5 electric",
                    year: 2025
                },
                licensePlate: "REN-1234",
                licensePlateState: "CA"
            },
            entry: {
                timestamp: "2025-03-31T04:00:00Z"
            },
            exit: {
                "timestamp": "2025-04-31T16:45:00Z"
            },
            mroType: MROType.IN_VEHICLE_TELEMATICS,
            distance: {
                value: 2005.04,
                unit: "mi"
            },
            locationName: "Location 1",
            totalAmount: {
                amount: 39.98,
                currency: "USD"
            },
            createdAt: "2025-04-31T16:45:00Z"
        },
        {
            id: "d8c931F9-0b86-5e41-06eg-79e0b8e7b66d",
            type: ActivityType.RUC,
            status: {
                name: ActivityNameStatus.CREATED,
                reason: ActivityReason.ACTIVITY_CREATED,
                dateTime: "2025-04-31T16:45:00Z"
            },
            vehicle: {
                vin: "JH5LA9470MS016526",
                details: {
                    make: "Tesla",
                    model: "Model 3 Long Range",
                    year: 2018
                },
                licensePlate: "TES-1234",
                licensePlateState: "CA"
            },
            entry: {
                timestamp: "2025-03-31T08:00:00Z"
            },
            exit: {
                timestamp: "2025-03-31T09:45:00Z"
            },
            mroType: MROType.PLUG_IN_DEVICE,
            distance: {
                value: 2005.6,
                unit: "mi"
            },
            totalAmount: {
                amount: 24.06,
                currency: "USD"
            },
            locationName: "Location 1",
            createdAt: "2025-04-31T16:45:00Z"
        },
    ],
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalElements: 1,
        pageSize: 10,
    },
};
